



















































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import DatePicker from 'vue2-datepicker'

import FetchErrorMixin from '@/components/mixins/fetchErrors'
import { Action } from '@/store/interview'
import { start } from 'repl'

export interface ComponentData {
  endsAt: string | Date
  startsAt: string | Date
}

export default mixins(FetchErrorMixin).extend({
  components: { DatePicker },
  data(): ComponentData {
    let startsAt = new Date(
      new Date(new Date().getTime() + 24 * 3 * 60 * 60 * 1000).setHours(8, 0, 0, 0)
    )
    const endsAt = new Date(startsAt.getTime() + 60 * 60 * 1000 /* ms */)
    return {
      endsAt,
      startsAt,
    }
  },
  methods: {
    createNewSlot() {
      this.reset()
      this.$store
        .dispatch({
          type: 'interview/offers/create',
          startsAt: this.startsAt,
          endsAt: this.endsAt,
          interviewerId: this.$store.getters.currentUserId,
          onError: (e) => {
            if (e.errcode == '23P01') {
              return this.catchError(e)
            } else {
              throw e
            }
          },
        })
        .then(() => {
          if (!this.hasErrors) {
            this.$refs['modal'].hide()
          }
        })
    },
  },
  watch: {
    startsAt(newDate: Date, oldDate: Date) {
      if (newDate && oldDate) {
        const difference = newDate.getTime() - oldDate.getTime()
        this.endsAt = new Date(this.endsAt.getTime() + difference)
      }
    },
  },
})
